import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { styled } from "@mui/material/styles";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useNavigate, Navigate } from 'react-router-dom';
import CircularIndeterminate from 'Components/loader/CircularIndeterminate'

const StyledBox = styled(Box)`
    background-color: ${({ theme }) => theme.palette.primary.dark};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;

  `;

const StyledContainer = styled(Container)`
  max-width: 600px;
  margin-top: 150px;
    `;

const StyledTypography = styled(Typography)`
color: ${({ theme }) => theme.palette.primary.contrastText};
font-weight: bold;
`;

const MicrosoftRedirect = () => {


  const navigate = useNavigate();
  const [idToken, setIdToken] = useState(null)


  console.log("this is ms token data", location.href)

  useEffect(() => {
    if (location.hash.includes("id_token")) {
      localStorage.setItem("ms_hash", location.hash)
      //get id_token from redirect location href and storing it in local storage
      let url_string = null

      if (/^azurewebsites.net/.test(window.location.host)) {
        url_string = (location.href).replace("callback#", "callback?")
      } else {
        url_string = (location.href).replace("sign_in#", "sign_in?")
      }
      const queryString = new URL(url_string)
      let id_token = queryString.searchParams.get("id_token")
      localStorage.setItem("social_access_token", id_token)
      setIdToken(id_token)
      // navigate('/app/auth', { replace: true })
      // dispatch(ms_login())
      //close the popup after 2 seconds
      // setTimeout(() => {
      //   open(location, '_self').close()
      //   window.close()
      // }, 2000)
    }
  }, [])


  if (!location.hash.includes("id_token")) return <Navigate to="/app/login" />

  // useEffect(() => {
  if (idToken !== null) return <Navigate to="/app/auth" replace={true} />
  // }, [idToken])

  if (location.hash.includes("id_token")) {

    return (
      <>
        <Helmet>
          <title>Authentication using Microsoft</title>
        </Helmet>
        <StyledBox
        >
          <StyledContainer maxWidth="md">
            <StyledTypography
              align="center"
              variant="h1"
            >
              Redirecting you to microsoft sign in for authentication
            </StyledTypography>
            <Box sx={{ textAlign: 'center' }}>
              <CircularIndeterminate />
            </Box>
          </StyledContainer>
        </StyledBox>
      </>
    );
  }
}

export default MicrosoftRedirect;
